import React, { useEffect, useState } from "react";
import "../modals/p2p.css";
import { BiBook, BiMinus, BiPlus } from "react-icons/bi";
import SelectWithImages from "./SelectWithImages";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select, { components } from "react-select";
import { getP2PCurrencyLimitation } from "../redux/helpers/api_functions_new";

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <img
        src={props.data.image}
        alt={props.data.label}
        style={{ width: 20, height: 20, marginRight: 10, borderRadius: "50%" }}
      />
      {props.data.label}
    </components.Option>
  );
};

const assets_options = [
  {
    value: "USDT",
    label: "USDT",
    image:
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxIQEhIQEBIVEBUVEBASEBYWDxUVFRYQFhIWGBcVFRUYHSggGBolGxUVITEhJSkrLi4uFx8zODMsNygtLisBCgoKDg0OFxAQFysdHR0tLS0tLSstKy0rLS0tLS0tKy0tLS0tLS0tLS4tLS0tLS0tLS0tLS0tLS0tLS0rLS0tLf/AABEIAOEA4QMBEQACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAUCAwYBB//EAEoQAAEDAgIFBggLBgQHAAAAAAEAAgMEEQUhEjFBUXEGEyJhgZEyM1JyobGy0QcUFiNCU2KiwdLwFVRzgpKUJDSz4URjg4SFk8L/xAAaAQEAAwEBAQAAAAAAAAAAAAAAAQIDBAUG/8QAMREBAAICAAUCAwcEAwEAAAAAAAECAxEEEiExQQVREzJxFSJCYYGxwSMzUqGR0fAU/9oADAMBAAIRAxEAPwD7igICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIF0Gp1Qwa3DvU6UnJWPLWa6Pyk0r8anufHo/KTUnxqe7NtUw6nBNJjLSfLa1wOo3ULxMT2eokQEBAQEBAQEBAQEBAQEBAQEBAQEEWpr2M1m53BTpjkz0p3lWT4w4+CLK0VcduLtPywgy1b3a3HvU6YWyWnvLQ6YbSe9SpzR7sDMP0VGkc1Tnh+ip0jmq9bMN571C24926OpcNTk0vF5jtKbDjD2+FmO9RMNq8VeO6ypsVY/bYqunVj4ml/yTgb6lDp3t6gICAgICAgICAgICAgICAg0VVWyMXceA2lTEbZ5MtccbtKirMWc/JvRHV+KvFXm5eKtfpXpCufLtJup05ptHlHkqlOmdsqO+pO9GU5Gh1UivNLE1SI3Lz4yhuWTalSnmluZUqFoyS3x1Saa1yt7ZQeoqGkWiU2kxN8RFzdqiYb4+IvT6OhosQZLqNju9ypMaeliz1ydu6WobCAgICAgICAgICAgICCvxPEhENEZvOobB1lWiNuXiOJjH0jrZzc0xcS55uSr6eVaZtO7zuUWWdSytfxCHNUIx3MqusxVjMi653DMps5UE180ni49Eb3e5RtbTJtJO7wpLcBZQNgwk7ZHHtUjL9kkanu70D4nK3wZCeOaImATSs8JocOrWpRpKp64HK9juKbRpOjnRMWmEmOoTTauTxLa15b0mkhFtzHWro8FxsSWjkNnfROx3UetZ2q9LheNi/3b9J/ddqr0BAQEBAQEBAQEBAQQcUr+abYZvPgjd9o9SmIc3EZ/hxqPmns5iZ9rlx0nHMlaRDyZnW5meqFNMrOe1plWVtcGAucbBRMq62onVMtQbM+bZv2kfgq7W1EJ1FhTGZ2udpOZUkysWRgKdIbAEHqD1Big8LQgizUjXbERpHGnH9oIrMJ1PUB2YU7EyOVQ0pbTY7PMKUzHmHT8nsY5z5qQ9MDonygPxCytXT1eC4vn+5fv+69VXoiAgICAgICAgINVVOI2l7tnpOwBTCmS8UrNpcpVTkkvdm4+gbAOoK8Q8fJedza3eVbNKruO1plUYniDY2kk8BvVZlEQo4IH1Ducl1fRbsA61HdK9giAFgpiEN4ClD26D3SRJpIGkg80kHl0HhKDxwBQQpoi06TO1QrpJpKkOG47Qp2hOjepXrZ6XEEOabEEEEbCFCe080O4wTERURh2pw6Mg+1v4HWsrRqXvcLn+NTfmO6wUOkQEBAQEBAQEHP4zU6b9EHos9L9vdq71esPO4nJzW14j91DUSXN+5XeXktuVXXVQYCTsSZZOZhaah/OO8EHoD8VVZeQtsFKFzhmEOnYXsc0AOLc73uADsHWom2nXg4S2avNEpfyal8tn3vcnM2+zr+8PPkzJ9Yz73uTmPs6/vB8mZfrGfe9ycx9nX94PkzL9Yz73uTnPs6/vB8mZPrGfe9ycx9nX94efJmX6xn3vco5j7Ov7wfJmX6xn3vck2Ps6/vDw8mJfrGfe9ycx9nX94YycnZGNc4vYQ1pcfC1AX3JzIt6feI3uHP8+CrOBDm6LtNvaERMLWkqA8AhSqlg3RdKwav+LzBx8B3Rk807ew596i0bhtwuacWSJ8T3d+sn0QgICAgICAgj19Rzcbn7QLN845D0lTDPNfkpNnJVL7C2snWfWe0rSIeLknlrpWTPVnG5bF5jK8RDVrdwVJWhOpIA0ABSiZSX6lKHW8jvEH+M/2WLO3d7fp39qfqvFV3iAgICDxAQEGiu8VL/Ck9gqYUv8s/R8tpzkOCu+bbVKGNFJzb9H6LtXHciF4CrIeSi4UJns7XkrW87AAT0ozzbuA8E91u4rO0al7vBZfiYo33jouFV2CAgICAgIKXH5c2R8Xn1N9bu5Whw8XfrWv6ubq33J6slpDyctt2VOITaLSUliosNj0iXnWVVO+i4Y1WV2SBSOt5HeId/Gd7LFlbu9z0+f6U/Vd2VXcWRIg8QEBB7ZB4g0Yh4qX+FJ7JRS/yz9Hyym1DgtHzSU1qka54r5jWMwiFrSP0mA7lKYjptsRELbkhU6FQY9kjD/W3MejSVbR0d/p1+XJNff8Ah26ze0ICAgICAg5jFJbyyHydFg7G39bitI7PKz2/qWn9FDK7arw8u07lQ45JkG7z6FWUQULLAKYJT2hEDwghVbZLWZJJH5krmi++zSM1EwvW96xqJmFXKKj94n/uJfzKumkZ7+8/8okhqv3mf+4l/Mo0vGe/+UrDke+o+PUwfPM9um7Sa6eRzSOafrBNjnZRp08NmtbJEb2+vKHsCD5p8MM0zXUYhlkiu2p0ubley+cNr6JF7Z695Ry8TkmmteXARTVd/wDNVH91N+ZNOOeIn3WEDqr95qP7iX8ynTG3EW91jRickaU8zhtBnkIPUblWiGNs15/FK6hYrMG8NUo2wkaoSk4UfCbvBUrU6zMNyK9mVPNzcsUnkyMJ824v6LpMbhpity5K29pfTFi+lEBAQEBAQcZUvvzjt75D3vP4LR4d56Wn3mVVIVdwuexU3e0dqrKUymGSlVKaUAolIjwmaTwY3W3nojvda6jcNqcNlv2q3O5MSAaUr4ohvLj7relRzQ6a+nZJ6zMQr56XD2EiXE6cHaBJHcffPqVZs0r6fXzdngb8KFVCIK0zTabubY1t2l2g69yGWAtc6xqUbb4uFx0vExaZmH0C6h6DxByHL6PDy6n+P1LqZ1puY0dThePTv0HDLobRrRz58Vcmuadac0zDsJd4vFoW7ucfED6XNU7cs8FEx0t/pZwckdMXp6qCcdTvy6QU7ZW4C34bRLyTk5Ux64y7rYQ70DP0K0TDmvweav4d/RHsWmxBB2gix7lMS5piYnUswVKGLigzw19pBxsoXpOrQnSixPEqUWjVpRqoZFEPp1FLpxxv8qNju9oKxfT0nmrE+7ciwgICAgIOFk8X+t61h4Nv7avkVnE5/EPGDgPWqrJsOpSqkxDSLW7S4NHEmyJrG5iPd0OMvbhtLJURQOqpGNBsPCNyAXE2JawazYah2rK0y9/Hw+PDXcRufd8exPlxidWT/iDAw6mQfNADqePnPvKO6l+JnSsGHOlOlKXSO8p7i939TrlNOS2eZ8pLcHHWp0z+MveQuHBmIUrt0j/9J6aa8Pl3krD7coewIPl/w00vOPouplV6TD7kcfFX5dfm+bfsjijj+M3swe1iNew2z700r8Zb0WNYhTeKqZbC3Re7nW23aMlwOxF68Ravl9H5F44/FI5G1dO28eiBK0EMcTfJt82vG2xOsari8xMw7KcueurVhExqlFPKYwbjRDm3tfRNxY9eRV4nbyOJwxhvywgF6s53tE75xvH3KE1+aFvU+EeKmOy2T5pRZ9SiVX0XAj/hqf8AgRewFlL6TB/ar9ITkaiAgICAg4WUdAjcSO5xC1h4NvkV71ZxqDER84D1fiqyJcGpSq9n1IRK3w3li6MBtQwvt9NltL+ZpsDxBHBUmHqYPUJiIrkjf5tstLg9adIiFryb3uaeQnrHR0jxBVXXvh83nr/wwk+D2A5xTSNBzGkGvHZYNTaluArbtZFfyBePBnY7zo3N9RKnbGfTr+LNdHyQq6eZk8ZgkMZJa0yyNBu0jM6GWtRtOLg8mO8W6dF0a/Fh/wADSu4Yi4euFQ9PcvP2hi37hTD/AMkT6oUSqMewHEMQdG6aOmg5vnA0NqZH3D9G5J5seSEcfE4L5Na8I8PweS/SmiHmh7vWAp2544G/mVlT/B+z6c7neZGG+kl3qRevp8fis2SYRhVJnO+MuGyWYOcf+kMnf0lNtY4fBj7/AO5RMQ+EGBjeboojIQLNLmc1E0dTcnHhZvFNIvxtKxqkf9OdiqpZnOlmdpPcQSdXAAbABlZWh5GXJN7blJsrM26gF5G8fcia/NC1qj0jxUx2Tk+aUWc5KJVfSMFbangG6CL2Asn0uGNY6x+UJqNBAQEBAQcXXMs+Zu6R57HHSHrWlZeJlj716/nKocruBTYszMFQiWymOSIbnC6CNJBdBBqKC6rMJiUIU74/FOdH1se5h+6Qmmlclo7Tpn+2q+PwKqbtfp+3dV06acVkj8S05Jcpq+WsghmnL43OcHtMMQuBG4jpNYCMwNqjTrwcVe14rM931NQ9MQcH8KGP1dI6mFLLzWm2cyfNxvuWmPR8Npt4TtW9HNxGSaa1Lg3cq8Tk8Krl/lDGew0Jpx24m3u1OdUy5SzTSg7HzyPHc42VtOe/ETPlup8L6rdiaYTkWNPQAbFaIUm8rSGGylRsc1BMwiPpg7s/16FLTHG7JEpuSetFLT1mUWpBPRGsmw4nIKJTEbmIfVomaIDRsAA7Asn08RqNMkSICAgICDlMfj0ag7pGNd/M3on0BqvWejyuKjly/WFDILEhaPLt0lAxKK7VCsodG7YiE0IbCEQwcxEtL4UNo0tMFEwnbdyapg2tgP2nf6blWezq4Sf61X09UfQiD598KUWk+l82o9cSmHmeoWmJr+v8ORhpBlkraeZNljBTDcp0pMpjIFbSu25saDMBBi8bETC0oW6LHO39EI2p0rNmlxRi34JBztVC3YH6Z4MGln2gDtVbT0dXCU58tY9ur6Us30AgICAgICCh5XU5MbZRrjdn5jsj6dFWq4OPpvHF4/D+zlpjfMbfWtIePfr1R5G3FlKioc3QcoVS2ORDYg9QYFBqkCDdgA/xcPnO9hyrPZ1cHP8AWq+hrN9GIOH+EcdOm4T+uNWh5XqU9afr/DmYgrPLlNiUqS3tUjMIkJQe07C49thxRMdeiyqeiAwbBnxUNck6+7CG9ymWUOj5A0lzLUHqiZ6HO/8An0ql3renY+95+jslR6ggICAgICDXPCHtcxwuHNLTwIsitqxaJifL51LCYnvhfrY4i+8bD2gg9q2js+byUnHaaT4a1LJDroL5hQTCNC/YiqSCg9QeFBqeg3cn/wDNQ+c72HKtuzq4P+/V9DWb6MQcR8I3h03Cf1xq0PK9S70/X+HMRlXeUmRIhvaVKGd0GOs2CJWlFGGDSOzJvFG2PUfelpkfc5ozmZmUaUlxDGi7nENaNpcTYDvUSmtZtMRHl9OwihFPDHCM9FvSO9xzce8lZy+kxY4x0iseExQ0EBAQEBAQEHMcssOu0VLBmwWl649juw+g9StWXm+oYOavxK94/ZyrXXzWjxmYzyKlMT4QKqn0TcKETGmMb0Q2gogJQa3IN2Af5qHznew5Vt2dXB/36voizfRiDhvhH8Om4T+uNWh5XqXen6/w5iMq8PKS4lKEhpRD0nYEE6jptp4kovWu5bqiW+Q1DIIve0T0hEkfZGa+5D4XzjzVPHRaS2Lrfqc7gNXEncs7S9T0/B1+JP6O5VXrCAgICAgICAg8c0EWOYORHUg+d8oMLNJJl4p5PNncdrDw2bxwK1rO3z3GcNOG24+Wf/aQWuVnG2ghwsewqGkTFukotRSEZj9dYTaJrpoaUV0z0kQ8KCNMCM2ktOwgkEcCMwomFq2ms7hTVXxjW2pqB/3Uv5lXldVeJvH4kPTqv3mp/upfzKNL/wD1XjysKNsjgOckklI1acjn24aRNlMQ58mWbzuZT2xqzLba0KUNrGk6kSn0tJtKLVrtImlAGiEWtaI6QhvejNnhWHvrJREzJozld5LPedQHuVZnTq4bBOa+vHl9PpqdsbGxsGi1rQ1o3ALN9BWsVjUNqJEBAQEBAQEBAQR6+jZOx0Ug0muGe8HYQdhG9NqXpW9ZraOkvm+LYdJRyaD+kw+KfscNx3O6lpFnz/E8LbDb8mpkl1dy7b45thzChrW8dpeyUrXC4/3RaaR3qiSU5b/t7kZzWYatE8f1uRXTB7UQ0OiChO2s0wTRtmyLcg2tgJ2W/W5SnSRFRkomIWEdMG5lGkU8yxlqNgUK2vEdIQ3vUqPKKlkqpBFCLnW530Wt8px/V1WZb4cFsttQ+l4NhUdLGI4+L3HW5+1x/WSzfQYsVcdeWqejQQEBAQEBAQEBAQEEeuo452GOVoe06wfWDrB6witqRaNWjcPnePYBLRkvbeWHy7dJg/5gHtDLgtIs8PieBtj+9XrH+1dFUA7VZwJLJbalKYtMSktqwfCF+vao03jLE94ZGON2o24onlpPaWDqI/RIPaiJxW8NRon+SD2BFfh3jwCjd5I7gp6I+Hf2bRRHbYdqhaMV2YiY3Wb8M02tyVjvLF9WB4I7Sis5IjtCJLOTrKM7Wm3dHlmsm0RCVg2DzVp6HQjBs6QjLrDR9I+gbVSbO3h+EtkmJnpD6PhOFxUrBHE2w1uJzc529x2lUe3jx1xxqqai4gICAgICAgICAgICAgFByeOcio5CZKYiB+stt8048B4B6xl1K0Tpw5+Bx5OsdJcZXwT0p0aiN0edg7XGeDxl2Gx6laLPIy8LkxfNHR5HVA7VbbnbRMgzbMdhRMWlmKl28ot8S0eXpqnbyh8S0+Wt052kppHNaWsy9aKtb6gBJlbTCkEtQ7Qp43SnUdEdEec45N7SqzLfFw97/LDr8F5DgEPrHCQ6xG0nQHnO1u4ZDiqTL1cPA1r1v1dlGwNAa0BoAAAAsABsAGpQ72SAgICAgICAgICAgICAgICAgxewOBDgCDkQRcEdYQc3iPIakluWNdTu3xO0W/8ArILO4BTuXNk4TFfvGvo56r5A1TPEzxyjc9rozbi3SBPYFPN7uK/pn+NlZNyexCPXTOeN7JY3Du0gfQp5nPb0/LH5or6SrbrpKjsge72QVPNDOeCy/wCIymqzqpKjtp5G+sBOYjgs3skxYFiD9VK5vW6SNveC6/oUczSvAZZ8LKl5C1j/ABssUI+yHSu7uiPSVHM6KenT5mF/h/ISljzlL6k/bdZn9DbAjqN1G5dePgsVPG/q6aCFsbQxjWsaMg1rQ0AdQGpQ6oiIjUNiJEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQf/Z",
  },
];

const fiat_options = [
  {
    value: "TRY",
    label: "TRY",
    image:
      "https://cdn2.iconfinder.com/data/icons/world-currency/512/07-512.png",
  },
  {
    value: "AED",
    label: "AED",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOln-TjfUuSEKP8w4CQ5JnIAcYQoNSHvhytQ&s",
  },
  {
    value: "USD",
    label: "USD",
    image: "https://img.icons8.com/color/48/000000/us-dollar-circled--v1.png",
  },
];

const P2PPostAd = ({ activeStep, setActiveStep, data, setData }) => {
  const [minPrice, setMinPrice] = useState(80);
  const [maxPrice, setMaxPrice] = useState(90);

  const Schema = Yup.object().shape({
    asset_name: Yup.string().required("Please Select Asset"),
    fiat_name: Yup.string().required("Please Select Fiat"),
    selling_price: Yup.number()
      .required("Please Enter Selling Price")
      .min(minPrice, `Selling price must be at least ${minPrice}`)
      .max(maxPrice, `Selling price must not exceed ${maxPrice}`),
  });
  const [step1Data, setStep1Data] = useState({
    asset_name: data?.asset_name,
    fiat_name: data?.fiat_name,
    selling_price: data?.selling_price,
  });

  const [currencyType, setCurrencyType] = useState(null);
  const [fiatType, setFiatType] = useState(null);
  const [currencyLimit, setCurrencyLimit] = useState({});
  useEffect(() => {
    getP2PCurrencyLimitation().then((res) => {

      // console.log(res, "<<--------------res")
      setCurrencyLimit(res.data);

    }).catch((error) => console.log(error, "<<---------------- error"))
  }, [])

  useEffect(() => {
    currencyLimitChange();
  }, [currencyType, fiatType])

  const currencyLimitChange = () => {
    if (currencyType && fiatType) {
      setMinPrice(currencyLimit?.[currencyType]?.[fiatType]?.min ?? 80)
      setMaxPrice(currencyLimit?.[currencyType]?.[fiatType]?.max ?? 90)
    }
  }

  const onSubmit = async (values, onSubmitProps) => {
    setData((prev) => ({
      ...prev,
      ...values,
    }));
    setActiveStep(1);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
      border: '1px solid #ced4da',
      border: '0.5px solid #ffffff7e',
      borderRadius: '12px',
      paddingLeft: '20px',
      height: '46px',
      boxShadow: 'none',
      // '&:hover': {
      //   border: '1px solid #ffb703', 
      // },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: '#1f1f1f',
      border: '0.5px solid #ffffff7e',
      overflow: 'hidden',
      borderRadius: '12px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#5253547a' : state.isFocused ? '#5253547a' : '#1f1f1f',
      color: state.isSelected ? '#fff' : '#fff',
      '&:active': {
        backgroundColor: '#007bff42',
        color: 'black',
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? '#ccc' : '#fff',
      // textAlign:'center'
    }),
  };

  return (
    <div className="add_post_step_1">
      <Formik
        initialValues={{ ...step1Data }}
        enableReinitialize
        validationSchema={Schema}
        onSubmit={onSubmit}
      >
        {({ errors, touched, values, setFieldValue, setFieldTouched }) => (
          <Form className="mt-4">
            <div className="row mb-4">
              <div className="col-6">
                <Field name="asset_name" >
                  {({ field }) => (
                    <Select
                      {...field}
                      onChange={(e) => (setFieldValue("asset_name", e.value), setCurrencyType(e.value))}
                      value={assets_options.filter((option) =>
                        values?.asset_name?.includes(option.value)
                      )}
                      placeholder="Asset"
                      options={assets_options}
                      components={{ Option: CustomOption }}
                      styles={customStyles}
                    />
                  )}
                </Field>
                {errors.asset_name && touched.asset_name ? (
                  <small className="text-danger">{errors.asset_name}</small>
                ) : null}
              </div>
              <div className="col-6">
                <Field name="fiat_name" >
                  {({ field }) => (
                    <Select
                      {...field}
                      onChange={(e) => (setFieldValue("fiat_name", e.value), setFiatType(e.value))}
                      value={fiat_options.filter((option) =>
                        values?.fiat_name?.includes(option.value)
                      )}
                      placeholder="With Fiat"
                      options={fiat_options}
                      components={{ Option: CustomOption }}
                      styles={customStyles}
                    />
                  )}
                </Field>
                {errors.fiat_name && touched.fiat_name ? (
                  <small className="text-danger">{errors.fiat_name}</small>
                ) : null}
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-12">
                <Field
                  type="number"
                  name="selling_price"
                  id="selling_price"
                  placeholder="Enter Price"
                  className="form-control text-center"
                  autoComplete="off"
                  onChange={(e) => {
                    setFieldTouched("selling_price", true);
                    setFieldValue("selling_price", e?.target?.value);
                  }}
                />
                {errors.selling_price && touched.selling_price ? (
                  <small className="text-danger">{errors.selling_price}</small>
                ) : null}
              </div>


              {
                values?.fiat_name && <p>{`${minPrice} ${values?.fiat_name} - ${maxPrice} ${values?.fiat_name}`}</p>
              }

            </div>

            {/* <div className="d-flex justify-content-between w-50 mt-2">
                    <section>
                      <span className="fs-12">YOUR PRICE</span>
                      <h6>85.64</h6>
                    </section>
                    <section>
                      <span className="fs-12">HIGHEST ORDER PRICE</span>
                      <h6>89.64</h6>
                    </section>
                  </div> */}

            {/* <div className="mb-4 text-center">
                    <button type="submit" className="btn login_btn py-1 px-4">
                      Update
                    </button>
                  </div> */}
            <div className="mt-4 text-center">
              <button
                disabled
                className="btn px-4 rounded-2 text-white d-none"
                style={{
                  background: "#ffb703",
                }}
              >
                Back
              </button>
              <button
                type="submit"
                className="btn common_stepper_button"

              >
                {"Next"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default P2PPostAd;
